module.exports = __webpack_public_path__ + "static/trusona@2x-f22f6ec899e120169cf29370801faaa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/trusona@2x.jpg
// module id = 873
// module chunks = 33019919093843 122353984331245